import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { requiredFieldError } from '../helper';
import { generateSchema, repaymentAccountSource } from '../shared';

const defaultSchema = {
  status: z.string(),
};

const customSchemas = {
  [FINANCIAL_PRODUCT.FLEX]: {
    ...defaultSchema,
    applicant: z.object({
      termsAndConditions: z.object({
        capacityToPay: z
          .boolean({ required_error: requiredFieldError() })
          .refine(value => !!value, { message: requiredFieldError() }),
      }),
    }),
    payment: repaymentAccountSource,
  },
};

export const summarySchema = generateSchema<typeof customSchemas, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export type SummaryType = z.infer<typeof summarySchema>;
